import { DatasourcesEnum } from './datasources.utils';

export enum QueryTypeEnum {
  TABLE = 'TABLE',
  QUERY = 'QUERY',
  COLUMN = 'COLUMN',
  CLONED = 'CLONED',
  USER = 'USER',
  CW = 'CW',
  JOB = 'JOB',
  PIPELINE = 'PIPELINE',
  WIDGET = 'WIDGET',
  DASHBOARD = 'DASHBOARD',
  METRIC_TABLE = 'METRIC_TABLE',
}

export enum RelationTypeEnum {
  DOWNSTREAM = 'DOWNSTREAM',
  AF_DOWNSTREAM = 'AF_DOWNSTREAM',
  CREATES = 'CREATES',
  TRIGGERS = 'TRIGGERS',
  UPSTREAM = 'UPSTREAM',
  TU_DOWNSTREAM = 'TU_DOWNSTREAM',
  REFERS = 'REFERS',
  COLUMN = 'DOWNSTREAM_COLUMN',
  ACCESSED = 'ACCESSED',
  CLONED = 'CLONED_FROM',
  CW = 'CW_DOWNSTREAM',
  CW_VIRTUAL = 'CW_DOWNSTREAM_VIRTUAL',
}

export enum NodeTypeEnum {
  Dataset = 'Dataset',
  Datajob = 'Datajob',
  Dataflow = 'Dataflow',
  Pipeline = 'Pipeline',
  Platform = 'Platform',
  Compute = 'Compute',
  Owner = 'Owner',
  Field = 'Field',
  Dashboard = 'Dashboard',
  Widget = 'Widget',
  DataQuery = 'DataQuery',
  Alert = 'Alert',
  Incident = 'Incident',
  MLRegistry = 'MLRegistry',
  MLModel = 'MLModel',
}

export type LineageType = 'column' | 'table' | 'dashboard';

export const getLineageTabTitle = (dataSource: string, lineageType: LineageType, originalName: string): string => {
  if (!dataSource || dataSource !== DatasourcesEnum.MetricCatalog) {
    return originalName;
  }

  switch (lineageType) {
    case 'column':
      return 'Metric Column Lineage';
    case 'table':
      return 'Metric Lineage';
    case 'dashboard':
      return 'Metric Dashboard Column Lineage';
    default:
      return originalName;
  }
};
